import React, { useEffect } from 'react';
import Navigation from '../components/layout/nav';
import './home.css';
import './home2.css';
import './ticket.css'
import './ticket.css'
import hand from '../assets/logo2.svg';
import detailicon1 from './../assets/eventicon01.svg'
import detailicon2 from './../assets/eventicon02.svg'
import detailicon3 from './../assets/eventicon03.svg'
import detailicon4 from './../assets/eventicon04.svg'
import barcode from './../assets/barcode.svg'

// import CategoryCard2 from '../sections/category2';
import HeadingBlock from '../components/common/heading';
import Button from '../components/common/button';

const Ticket = () => {
  useEffect(() => {
    const originalColor = window.getComputedStyle(document.body).backgroundColor;
    document.body.style.setProperty('background-color', '#FFF4E2', 'important');

    return () => {
      document.body.style.removeProperty('background-color');
      document.body.style.backgroundColor = originalColor;
    };
  }, []);
  return (
    <>
    <header className='fixedWidth'>
        <HeadingBlock label="Ready to go!" heading="My Ticket" style1="dark left decor"/>
    </header>
      <main className='fixedWidth'>
        <div className="ticketBg1">
          <img className='handicon' src={hand} alt="" />
          <h1>
            EgyCraft Fair 2026
          </h1>
          <h6> Mohamed Ibrahim</h6>
          <div className="ticketidFlex">
            <h6>
              Ticket Id
            </h6>
            <h2>
               #EGY2026-001234
            </h2>
          </div>
           <div className="detailFlex">
            <div className="detailiconFlex ">
                <div className="color1">
                <img src={detailicon2} alt="Detail Icon 1" />
                </div>
                10am - 10pm
            </div>
            <div className="detailiconFlex ">
                <div className="color2">
                <img src={detailicon4} alt="Detail Icon 1" />
                </div>
                City Center Almaza
            </div>
            <div className="detailiconFlex ">
                <div className="color1">
                <img src={detailicon3} alt="Detail Icon 1" />
                </div>
                March 15-20
            </div>
        </div>
        </div>
        <div className="ticketBg1 ticketBg2">
          <img src={barcode} aria-label="scan here" alt="barcode" />
        </div>
      </main>
      <Navigation />
    </>
  );
};

export default Ticket;